import { render, staticRenderFns } from "./ExistingArticlesEditing.vue?vue&type=template&id=66dd7e46&scoped=true"
import script from "./ExistingArticlesEditing.vue?vue&type=script&lang=js"
export * from "./ExistingArticlesEditing.vue?vue&type=script&lang=js"
import style0 from "./ExistingArticlesEditing.vue?vue&type=style&index=0&id=66dd7e46&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66dd7e46",
  null
  
)

export default component.exports